import {ToastType} from 'common/components/toast/types';
import {addToast} from 'common/components/toast-area/toast-manager';
import {reporter} from 'common/report/error-reporting';
import {avatarsStore} from 'common/report/stores/avatars';

export async function updateAvatar(avatarPath: string) {
  try {
    const avatar = await (await fetch(avatarPath)).blob();
    await avatarsStore.post({avatar});
    avatarsStore.refreshAll(); // avatar store doesnt update on post, need to refresh
    addToast({message: `Avatar updated`, type: ToastType.SUCCESS});
    return true;
  } catch (err) {
    const message = err.userFriendly ? err.message : `Error updating avatar`;
    addToast({message, type: ToastType.ERROR});
    reporter.error(err);
    return false;
  }
}
